export default {
  h1: {
    fontWeight: 600,
    fontSize: 57,

    fontFamily:"Poppins",
    
   
    

    fontFamily: "Poppins",

  },
  h2: {
    fontWeight: 500,
    fontSize: 30,
    fontFamily: "Poppins",
  },
  h3: {
    fontWeight: 500,
    fontSize: 30,
    fontFamily: "'Inter',Sans-serif",
  },
  h4: {
    fontWeight: 500,
    fontSize: 18,
    fontFamily: "Poppins",
  },
  h5: {
    fontWeight: 400,
    fontSize: 16,
    fontFamily: "Poppins",
  },
  h6: {
    fontWeight: 400,
    fontSize: 12,
    fontFamily: "Poppins",
  },
  overline: {
    fontWeight: 500,
  },
  button: {
    textTransform: "capitalize",
    borderRadius: 27,
  },
  body1: {
    fontSize: 18,
    fontFamily: "'Roboto',Sans-serif",
    fontWeight: 400,
  },
  body2: {
    fontSize: 17,
    fontFamily: "Poppins",
    fontWeight: 400,
  },
};
